import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, Monitor, RotateCcw } from 'lucide-angular';
import { TranslatePipe } from '@shared/i18n/translate.pipe';
import { TabSyncService } from 'app/core/services/tab-sync.service';

@Component({
  selector: 'app-tab-conflict-overlay',
  imports: [CommonModule, LucideAngularModule, TranslatePipe],
  templateUrl: './tab-conflict-overlay.component.html',
})
export class TabConflictOverlayComponent {
  private tabSyncService = inject(TabSyncService);

  readonly Monitor = Monitor;
  readonly RotateCcw = RotateCcw;

  readonly isCurrentTabActive = this.tabSyncService.isCurrentTabActive;

  useHere(): void {
    this.tabSyncService.claimActiveTab(true);
  }
}
